export const types = [
    { cftid: "1", cftname: "Text" },
    { cftid: "2", cftname: "Number" },
    { cftid: "3", cftname: "True/False" },
    { cftid: "4", cftname: "Multiple Choice" },
    { cftid: "5", cftname: "Checklist" },
    { cftid: "6", cftname: "Star Rating" },
    { cftid: "7", cftname: "Attachment" },
];

export const tableFields: any = [
    {
        id: "employment",
        name: "Employment Status",
        pivot: false,
    },
    { id: "age_bracket", name: "Age Bracket", pivot: false },
    {
        id: "gender",
        name: "Gender",
        pivot: false,
    },
    {
        id: "volunteer",
        name: "Volunteer",
        pivot: false,
    },
    {
        id: "donor",
        name: "Donor",
        pivot: false,
    },
    { id: "party", name: "Organisation", pivot: true },
];

export const creditRatings: any = [
    "Under 499",
    "500-549",
    "550-599",
    "600-649",
    "650-699",
    "700-749",
    "750-799",
    "800+",
];

export const householdNetWorths: any = [
    "Less than $1",
    "$1 - $4,999",
    "$5,000 - $9,999",
    "$10,000 - $24,999",
    "$25,000 - $49,999",
    "$50,000 - $99,999",
    "$100,000 - $249,999",
    "$250,000 - $499,999",
    "Greater than $499,999",
];

export const dwellingTypes: any = [
    "Multiple Family Dwelling Unit",
    "Single Family Dwelling Unit",
];

export const homeOwnerStatuses: any = [
    "Home Owner",
    "Probable Home Owner",
    "Renter",
];

export const fieldTableColumns: any = {
    age_bracket: [
        {
            id: "18-29",
            name: "18-29",
            tooltip: null,
            selected: true,
        },
        {
            id: "30-49",
            name: "30-49",
            tooltip: null,
            selected: true,
        },
        {
            id: "50+",
            name: "50+",
            tooltip: null,
            selected: true,
        },
    ],
    employment: [
        {
            id: "Employed",
            name: "Employed",
            tooltip: null,
            selected: true,
        },
        {
            id: "Unemployed",
            name: "Unemployed",
            tooltip: null,
            selected: true,
        },
        {
            id: "Self Employed",
            name: "Self Employed",
            tooltip: null,
            selected: true,
        },
        {
            id: "Retired",
            name: "Retired",
            tooltip: null,
            selected: true,
        },
        {
            id: "Full Time Student",
            name: "Full Time Student",
            tooltip: null,
            selected: true,
        },
        {
            id: "Unspecified",
            name: "Unspecified",
            tooltip: null,
            selected: true,
        },
    ],
    gender: [
        {
            id: "Male",
            name: "Male",
            tooltip: null,
            selected: true,
        },
        {
            id: "Female",
            name: "Female",
            tooltip: null,
            selected: true,
        },
    ],
    volunteer: [
        {
            id: "Volunteer",
            name: "Volunteer",
            tooltip: null,
            selected: true,
        },
        {
            id: "Non-Volunteer",
            name: "Non-Volunteer",
            tooltip: null,
            selected: true,
        },
    ],
    donor: [
        {
            id: "Donor",
            name: "Donor",
            tooltip: null,
            selected: true,
        },
        {
            id: "Non-Donor",
            name: "Non-Donor",
            tooltip: null,
            selected: true,
        },
    ],
};
export const fieldIcons: string[] = [
    "directions_walk",
    "people",
    "call",
    "insert_emoticon",
    "list",
    "monetization_on",
    "question_answer",
    "check_box_outline_blank",
    "keyboard",
    "chat",
    "mail",
    "reply",
    "campaign",
    "assignment",
    "build",
    "date_range",
    "traffic",
    "event",
    "favorite",
    "face",
    "history",
    "home",
    "flag",
    "hearing",
    "keyboard_voice",
    "import_contacts",
    "content_cut",
    "weekend",
    "access_alarm",
    "local_airport",
    "local_bar",
    "local_cafe",
    "restaurant",
    "person_pin",
    "directions_bike",
    "subway",
    "wc",
    "all_inclusive",
    "golf_course",
    "whatshot",
    "thumb_up",
];
